import React, { FC } from 'react';

import LoaderIcon from '../../assets/icons/loader-icon';
import { RootPortal } from '../root-portal/index';

const RootLoader: FC = () => (
  <RootPortal>
    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
      <LoaderIcon className="size-16" />
    </div>
  </RootPortal>
);

export default RootLoader;
